import request from './request';

export function createLiveRoom(data) {
  return request.post('/api/live_room/create', data);
}
export function startLive(roomId, data = {}) {
  return request.post('/api/live_room/start', { room_id: roomId, ...data });
}
export function stopLive(roomId) {
  return request.post('/api/live_room/stop', { room_id: roomId });
}
export function getMyRoom() {
  return request.get('/api/live_room/myRoom');
}
export function getLivingList(params) {
  return request.get('/api/live_room/livingList', { params });
}
export function getRoomInfo(id) {
  return request.get('/api/live_room/info', { params: { id } });
}
export function addRoomView(id) {
  return request.post('/api/live_room/addView', { id });
}
export function addRoomLike(id) {
  return request.post('/api/live_room/addLike', { id });
}
export function sendRoomDanmaku(data) {
  return request.post('/api/live_room/sendDanmaku', data);
}
// 复用直播消息流增量拉取（video_id 传直播间ID，仅取 chat 类型作为弹幕）
export function pullRoomChat(params) {
  return request.get('/api/live_chat/pull', { params });
}
